import { render } from "./numberModal.vue?vue&type=template&id=6db9aace"
import script from "./numberModal.vue?vue&type=script&lang=js"
export * from "./numberModal.vue?vue&type=script&lang=js"

import "./numberModal.vue?vue&type=style&index=0&id=6db9aace&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__